import React from "react";
import DietPlanOverview from "@features/diet/DietPlanOverview";

const MealsListing = ({
  weeklyMeals,
  day,
  tab,
  setTab,
  initialSelectedMeal,
  startDate = null,
  date = null,
}) => {
  const selectedDay = day;
  const selectedMeal = weeklyMeals.find((meal) => meal.title === selectedDay);

  return (
    <DietPlanOverview
      selectedMeal={selectedMeal}
      selectedDay={selectedDay}
      selectedMeals={initialSelectedMeal.selectedMeals}
      variant="mealListing"
      showHeader={true}
      showClock={true}
      navigateTo="/diet-plan/recipe-detail"
      stateKey="mealListing"
      tab={tab}
      setTab={setTab}
      startDate={startDate}
      date={date}
    />
  );
};

export default MealsListing;
